import React from "react";

const OrdersLoadingSimple = () => {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-lg border border-gray-700 bg-gray-800 p-4"
        >
          {/* Header Row */}
          <div className="mb-2 flex items-start justify-between">
            {/* Order ID */}
            <div className="flex-1">
              <div className="h-6 w-32 rounded bg-gray-700"></div>
            </div>

            {/* Price and Date */}
            <div className="text-right">
              <div className="mb-1 h-6 w-16 rounded bg-gray-700"></div>
              <div className="h-4 w-20 rounded bg-gray-700"></div>
            </div>
          </div>

          {/* Items Description */}
          <div className="h-4 w-3/4 rounded bg-gray-700"></div>
        </div>
      ))}
    </div>
  );
};

export default OrdersLoadingSimple;
